
import { ColumnsType } from "antd/es/table";


const width = "22%";
const pgp1: ColumnsType = [
  {
    title: "-",
    dataIndex: "none",
    width: "12%",
    align:'center',
  },

  {
    title: "Cầu",
    dataIndex: "sph",
    align:'center',


    width: width,
  },
  {
    title: "Trụ",
    dataIndex: "cyl",
    align:'center',

    width: width,
  },
  {
    title: "Trục",
    dataIndex: "axis",
    align:'center',

    width: width,
  },
  {
    title: "Thị lực",
    dataIndex: "vision",
    align:'center',

    width: width,
  },

];

export { pgp1 };
